import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import MembershipSellModal from '../components/MembershipSellModal';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import {
    listMemberships, sellMembership, visitsSummary, ESTADO_SOCIO, formatYMD,
} from '../utils/membershipsApi';

const pesos = (n) => `$ ${Number(n || 0).toLocaleString('es-UY', { maximumFractionDigits: 0 })}`;

// Socios del club: quién es socio, hasta cuándo, y el alta/renovación en el mostrador.
// Los planes (precio, duración) se administran en Configuraciones → Membresías.
class MembershipsPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            loading: true,
            memberships: [],
            status: 'active',
            q: '',
            error: null,
            form: false,
            aviso: null,
            resumen: null, // visitas de socios de las últimas 8 semanas
        };
    }

    async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
        this.load();
        try {
            this.setState({ resumen: await visitsSummary() });
        } catch (e) { /* el resumen es accesorio: la grilla se usa igual */ }
    }

    load = async () => {
        this.setState({ loading: true, error: null });
        try {
            const data = await listMemberships({ status: this.state.status, q: this.state.q.trim() });
            this.setState({ memberships: (data && data.members) || [], loading: false });
        } catch (e) {
            this.setState({ error: e.message, loading: false });
        }
    }

    vender = async (payload) => {
        const data = await sellMembership(payload);
        const m = data.membership;
        const texto = data.renewedFrom
            ? `Renovación registrada: del ${formatYMD(m.valid_from)} al ${formatYMD(m.valid_until)} (la anterior vencía el ${formatYMD(data.renewedFrom)}).`
            : `Membresía registrada: del ${formatYMD(m.valid_from)} al ${formatYMD(m.valid_until)}.`;
        this.setState({ form: false, aviso: texto, status: 'active', q: '' }, this.load);
    }

    // Una fila por SOCIO: la membresía es una y se va renovando. Los períodos, los pagos y la
    // baja viven en el detalle.
    renderFila = (m, index) => {
        const estado = ESTADO_SOCIO[m.state] || { label: m.state, badge: 'badge-secondary' };
        const nombre = m.user ? `${m.user.firstName || ''} ${m.user.lastName || ''}`.trim() : '';
        let cobertura;
        if (m.state === 'vigente') cobertura = <>hasta el <b>{formatYMD(m.coveredUntil)}</b></>;
        else if (m.state === 'futura') cobertura = <>empieza el <b>{formatYMD(m.nextFrom)}</b><br /><small className="text-muted">cubre hasta el {formatYMD(m.coveredUntil)}</small></>;
        else if (m.state === 'vencida') cobertura = <>venció el {formatYMD(m.lastUntil)}</>;
        else cobertura = <span className="text-muted">—</span>;
        return (
            <tr role="row" key={m.cedula} style={{ background: index % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                <td className="text-left">
                    <div>{nombre || <span className="text-muted">Sin ficha</span>}</div>
                    <small className="text-muted">{m.cedula}{m.user && m.user.email ? ` · ${m.user.email}` : ''}</small>
                </td>
                <td className="text-left">{m.planName || '—'}</td>
                <td><span className={'badge ' + estado.badge}>{estado.label}</span></td>
                <td>{cobertura}</td>
                <td>{m.memberSince ? formatYMD(m.memberSince) : '—'}</td>
                <td>
                    {/* Visitas del período en curso (días distintos) y la última. */}
                    {m.visits && m.visits.period ? (
                        <>
                            <b>{m.visits.period.total}</b>
                            <small className="text-muted d-block">{m.visits.period.mesa} mesa · {m.visits.period.club} club</small>
                        </>
                    ) : '—'}
                    {m.visits && m.visits.last ? <small className="text-muted d-block">última {formatYMD(m.visits.last)}</small> : null}
                </td>
                <td className="text-right text-nowrap">
                    {/* Atajo del mostrador: el mismo alta con la cédula y el plan ya puestos; el
                        backend encadena el período nuevo al último pago. */}
                    <button type="button" className="btn btn-sm btn-white mr-1"
                        onClick={() => this.setState({ form: true, aviso: null, renovar: { cedula: m.cedula, planId: m.planId } })}>
                        Renovar
                    </button>
                    <button type="button" className="btn btn-sm btn-white"
                        onClick={() => navigateTo(`/membershipDetail?cedula=${encodeURIComponent(m.cedula)}`)}>
                        Ver detalle
                    </button>
                </td>
            </tr>
        );
    }

    renderCuerpo() {
        if (this.state.loading) {
            return (<tr><td colSpan="7" className="text-center" style={{ padding: 30 }}>Cargando…</td></tr>);
        }
        if (this.state.error) {
            return (<tr><td colSpan="7" className="text-center" style={{ padding: 30, color: '#C4183C' }}>{this.state.error}</td></tr>);
        }
        if (!this.state.memberships.length) {
            return (
                <tr><td colSpan="7" className="text-center" style={{ padding: 30, color: '#818EA3' }}>
                    {this.state.status === 'active' && !this.state.q
                        ? 'Todavía no hay socios. Registrá la primera membresía con el botón de arriba.'
                        : 'No hay socios con ese filtro.'}
                </td></tr>
            );
        }
        return this.state.memberships.map(this.renderFila);
    }

    // Visitas de socios de las últimas semanas, por plan: cuánto se usa cada plan y cuánta
    // entrada de mesa no se cobró por los lugares sin cargo.
    renderResumen() {
        const r = this.state.resumen;
        if (!r || !r.totals) return null;
        return (
            <div className="card card-small mb-4">
                <div className="card-header border-bottom">
                    <h6 className="m-0">Visitas de socios</h6>
                    <small className="text-muted">Del {formatYMD(r.from)} al {formatYMD(r.to)} · una visita = un socio, un día, mesa o club</small>
                </div>
                <div className="card-body" style={{ fontSize: 13 }}>
                    <div className="row mb-3">
                        <div className="col-md-3"><small className="text-muted d-block">Visitas</small><b>{r.totals.visits}</b> <span className="text-muted">({r.totals.mesa} mesa · {r.totals.club} club)</span></div>
                        <div className="col-md-3"><small className="text-muted d-block">Socios que vinieron</small><b>{r.totals.members}</b></div>
                        <div className="col-md-3"><small className="text-muted d-block">Lugares de mesa sin cargo</small><b>{r.totals.freeSeats}</b></div>
                        <div className="col-md-3"><small className="text-muted d-block">Entrada no cobrada (a precio de hoy)</small><b>{pesos(r.totals.coverNotCharged)}</b></div>
                    </div>
                    {r.plans && r.plans.length ? (
                        <table className="table table-sm mb-0">
                            <thead>
                                <tr><th>Plan</th><th>Socios</th><th>Mesa</th><th>Club</th><th>Sin cargo</th></tr>
                            </thead>
                            <tbody>
                                {r.plans.map((p) => (
                                    <tr key={p.planId || 0}>
                                        <td>{p.planName}</td><td>{p.members}</td><td>{p.mesa}</td><td>{p.club}</td><td>{p.freeSeats}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : <span className="text-muted">Sin visitas en el período.</span>}
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.checked) return (<div></div>);
        return (
            <div className="container-fluid">
                {this.state.form ? (
                    <MembershipSellModal
                        renovar={this.state.renovar}
                        onCancel={() => this.setState({ form: false, renovar: null })}
                        onSell={this.vender} />
                ) : null}
                <div className="row">
                    <SidebarComponent itemSelected={49} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <HeaderComponent title="Cafetería" subtitle="Membresías" />
                                <button type="button" className="btn btn-accent" onClick={() => this.setState({ form: true, renovar: null, aviso: null })}>
                                    + Nueva membresía
                                </button>
                            </div>

                            {this.state.aviso ? (
                                <div className="alert alert-success" role="alert">{this.state.aviso}</div>
                            ) : null}

                            <div className="card card-small mb-4">
                                <div className="card-header border-bottom d-flex align-items-center flex-wrap" style={{ gap: 12 }}>
                                    <h6 className="m-0 mr-auto">Socios</h6>
                                    <select className="form-control" style={{ width: 'auto' }} value={this.state.status}
                                        onChange={(e) => this.setState({ status: e.target.value }, this.load)}>
                                        <option value="active">Vigentes</option>
                                        <option value="expired">Vencidas</option>
                                        <option value="cancelled">Dadas de baja</option>
                                        <option value="all">Todas</option>
                                    </select>
                                    <input type="text" className="form-control" style={{ width: 240 }} placeholder="Cédula, nombre o email"
                                        value={this.state.q}
                                        onChange={(e) => this.setState({ q: e.target.value })}
                                        onKeyDown={(e) => { if (e.key === 'Enter') this.load(); }} />
                                    <button type="button" className="btn btn-white" onClick={this.load}>Buscar</button>
                                </div>
                                <div className="card-body p-0 pb-3">
                                    <div className="dataTables_wrapper no-footer">
                                        <table className="transaction-history dataTable no-footer dtr-inline" role="grid">
                                            <thead>
                                                <tr role="row">
                                                    <th className="text-left" style={{ width: '24%' }}>Socio</th>
                                                    <th className="text-left" style={{ width: '14%' }}>Plan</th>
                                                    <th style={{ width: '12%' }}>Estado</th>
                                                    <th style={{ width: '15%' }}>Cobertura</th>
                                                    <th style={{ width: '9%' }}>Socio desde</th>
                                                    <th style={{ width: '10%' }} title="Días que vino en el período actual">Visitas</th>
                                                    <th style={{ width: '16%' }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>{this.renderCuerpo()}</tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {this.renderResumen()}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default MembershipsPage;
